import {useCallback, useRef} from 'react'

export function useRefs<T extends {}>() {
  const refs = useRef<Partial<Record<keyof T, HTMLElement | null>>>({})

  const setRef = useCallback((key: keyof T) => {
    return (ref: HTMLElement | null) => {
      refs.current[key] = ref
    }
  }, [])

  const getRef = useCallback((key: keyof T) => {
    return refs.current[key] || null
  }, [])

  return {getRef, setRef}
}
